import { Box, Button, Menu, MenuItem, Tooltip, Typography, Checkbox } from "@material-ui/core";
import { MoreVertRounded, Visibility, VisibilityOff, RemoveSharp, AddSharp, DoneSharp } from "@material-ui/icons";
import React, { MouseEvent, useRef, useState } from "react";
import { useStyles } from "./styles";
import CustomDialog from "../../../shared/layout/custom-dialog";
import {getActiveTab} from '../../components/company-list/list-filters'
interface ActionMenuProps {
  companyIsHidden: boolean;
  name?: string,
  handleHiddenStateChange?: (actionType: "HIDE" | "UN_HIDE") => void;
  filterType?: string;
  isAdmin: boolean;
  handleUpdateCompanyList?: (actionType: "ADD" | "REMOVE") => void;
  isAddedToPortfolio?: boolean;
}
export const ActionMenu = (props: ActionMenuProps) => {
  const { companyIsHidden, handleHiddenStateChange, name, isAdmin, handleUpdateCompanyList, isAddedToPortfolio } = props;
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { isMyPortfolio } = getActiveTab(props.filterType);
  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (actionType?: "HIDE" | "UN_HIDE" | null) => {
    setAnchorEl(null);
    if (!actionType) return;
    handleHiddenStateChange(actionType);
  };

  return (
    <>
      {isMyPortfolio ? (
        <Box visibility={!isAddedToPortfolio && "hidden"}>
          <CustomDialog
            trigger={
              <>
                <Tooltip title="Remove from Portfolio" arrow placement="top">
                  <Button
                  className={styles.buttonTypography}
                    aria-controls="customized-menu"
                    aria-haspopup="true"
                    variant="text"
                    color="primary"
                    startIcon={<RemoveSharp />}
                  >
                    REMOVE
                  </Button>
                </Tooltip>
              </>
            }
            title="Remove from Portfolio?"
            actions={(handleClose) => (
              <>
                <Button color="primary" onClick={handleClose}>Cancel</Button>
                <Button color="primary" autoFocus onClick={() => {
                  handleUpdateCompanyList('REMOVE')
                  handleClose();
                }}>
                  Confirm
                </Button>
              </>
            )}
          >
            <Typography className={styles.dialogText}>
              Remove {name} from your portfolio? You can add them back at any time.
            </Typography>
          </CustomDialog>
        </Box>
      ) : (
        <CustomDialog
          trigger={
            <>
              <Tooltip title={isAddedToPortfolio ? "Added to Portfolio" : "Add to Portfolio"} arrow placement="top">
                <span>
                  <Button
                    className={`${styles.buttonText} ${styles.buttonTypography}`}
                    aria-controls="add-button"
                    variant="text"
                    color="primary"
                    startIcon={isAddedToPortfolio ? <DoneSharp /> : <AddSharp />}
                    disabled={isAddedToPortfolio}
                  >
                    {isAddedToPortfolio ? "ADDED" : "ADD"}
                  </Button>
                </span>
              </Tooltip>
            </>
          }
          isButtonDisabled={isAddedToPortfolio}
          title="Add to Portfolio?"
          actions={(handleClose) => (
            <>
              <Button color="primary" onClick={handleClose}>Cancel</Button>
              <Button color="primary" autoFocus onClick={() => {
                handleUpdateCompanyList('ADD')
                handleClose();
              }}>
                Confirm
              </Button>
            </>
          )}
        >
          <Typography className={styles.dialogText}>
            Add {name} to your portfolio? You can remove them at any time.
          </Typography>
        </CustomDialog>

      )}
      {
        isAdmin && (
          <>
            <Button
              className={`${styles.buttonText} ${styles.buttonTypography}`} 
              aria-controls="customized-menu"
              aria-haspopup="true"
              variant="text"
              color="primary"
              startIcon={<MoreVertRounded />}
              onClick={handleOpen}
            >
              MORE
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              elevation={0}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => handleClose()}
              classes={{
                paper: styles.paper,
                list: styles.list,
              }}
            >
              {!companyIsHidden && (
                <MenuItem onClick={() => handleClose("HIDE")}>
                  <VisibilityOff /> Hide Company
                </MenuItem>
              )}
              {companyIsHidden && (
                <MenuItem onClick={() => handleClose("UN_HIDE")}>
                  <Visibility /> Unhide Company
                </MenuItem>
              )}
            </Menu>
          </>)
      }
    </>
  );
};
